/**
 * Decides when Tailor brings up notifications on its own.
 *
 * Whenever the panel is open and Tailor is not mid-turn, any unseen
 * notification it has not already brought up gets one turn — whether it was
 * waiting when the panel opened or raised while the conversation was on
 * something else. Each is brought up once per opening: if that turn never
 * lands (it failed, or the panel closed first), the next opening tries again.
 */
export class CopilotNotificationSurfacer {
  private readonly surfaced = new Set<string>();

  shouldSurface(state: { open: boolean; busy: boolean; unseenIds: readonly string[] }): boolean {
    if (!state.open) {
      this.surfaced.clear();

      return false;
    }

    if (state.busy) {
      return false;
    }

    const fresh = state.unseenIds.filter((id) => !this.surfaced.has(id));

    if (!fresh.length) {
      return false;
    }

    for (const id of fresh) {
      this.surfaced.add(id);
    }

    return true;
  }
}
